import { LegalPage } from '../../components/legal-page';
import { PRIVACY } from '../../content/legal';

/** /privacy — политика конфиденциальности (ЗРУ-547). Public. */
export function Privacy() {
  return <LegalPage doc={PRIVACY} canonical="/privacy" />;
}
